export function templateFromString(env, template, name = null) {
    return env.createTemplate(template, name);
}
